import { POReceivingDetailPage } from "@/features/po-receiving/pages/POReceivingDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["po_receiving.view_detail"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingDetailPage,
});
